import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {LinkButtonNew} from '@components/common/base/buttons'
import {MessageBox} from '@components/message-box'
import {RemoveStickerPopup} from '@components/sticker/my-stickers/board-stickers/remove-sticker-popup'
import {useMyStickersStore} from '@components/sticker/my-stickers/my-stickers-store'
import {useBoolean} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {Sticker} from '@extensions/sticker/sticker'
import {StickerLibrary} from '../../../my-stickers-utils'

const TwToggle = tw.div`
  flex
  self-start
  flex-1
  w-0
  cursor-pointer
  text-main-old
`

const TwButton = tw(LinkButtonNew)`
  invisible
  group-hover:visible
`

export const ListItemToggleSticker = observer(
  ({stickerLibrary, board}: {stickerLibrary: StickerLibrary; board: Hub}) => {
    const [, store] = useMyStickersStore()
    const removePopup = useBoolean(false)
    const addClick = (): void => {
      Sticker.addToBoard(board, stickerLibrary.sticker)
      store.syncLibrary(board)
      MessageBox.show(Lang.msg.myStickers.settingsApplied, 'success', {
        modern: true
      })
    }
    const canRemove =
      PermissionsChecker.isAdmin() ||
      stickerLibrary.sticker.data.by === globals.currentUserId
    return (
      <TwToggle>
        <div className="flex flex-col gap-8">
          <TwButton
            onClick={addClick}
            icon="IconPlus"
            title={Lang.msg.myStickers.addToCurrentBoard}
          />
          {canRemove && (
            <TwButton
              onClick={removePopup.turnOn}
              color="notification-primary"
              icon="IconTrash"
              title={Lang.msg.myStickers.removeFromSystem}
            />
          )}
        </div>
        {removePopup.value && (
          <RemoveStickerPopup
            sticker={stickerLibrary.sticker}
            close={() => {
              removePopup.turnOff()
              store.syncLibrary(board)
            }}
            removeFrom="system"
          />
        )}
      </TwToggle>
    )
  }
)
